<template>
  <p>Yönlendiriliyorsunuz...</p>
</template>
<script>
import {getTransaction} from "@/api/transaction";
import { mapState } from 'vuex';

export default {
  data() {
    return {
      loading: false,
      transaction: null
    }
  },
  computed: {
    ...mapState({
      config: state => state.auth.config,
    }),
  },
  methods: {
  },
  mounted() {
    this.loading = true;
    getTransaction(this.$route.params.transactionId).then((response) => {
      if(response.data.data.type === "deposit") {
        if (response.data.data.bankType === "hizli") {
          window.location.href = response.data.data.params.url
        }
        this.loading = false;
      }
    })
  }
}
</script>
